import { Button, ButtonVariants } from '../Button';
import { Modal, ModalFooter, ModalHeader } from '../Modal';

export interface IConfirmationModal {
  isActive: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  content?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmButtonVariant?: ButtonVariants;
  cancelButtonVariant?: ButtonVariants;
}

export const ConfirmationModal = ({
  isActive,
  onConfirm,
  onCancel,
  content,
  title = 'Jeste li sigurni?',
  confirmText = 'Da',
  cancelText = 'Ne',
  confirmButtonVariant = 'warning',
  cancelButtonVariant = 'primary-ghost',
}: IConfirmationModal) => {
  return (
    <Modal
      className="confirmation-modal"
      isActive={isActive}
      onClose={onCancel}
      modalHeader={<ModalHeader onClose={onCancel} title={title} />}
      modalFooter={
        <ModalFooter>
          <Button
            type="button"
            size="small"
            variant={cancelButtonVariant}
            disabled={false}
            onClick={onCancel}
          >
            <span>{cancelText}</span>
          </Button>
          <Button
            type="button"
            size="small"
            variant={confirmButtonVariant}
            onClick={onConfirm}
          >
            <span>{confirmText}</span>
          </Button>
        </ModalFooter>
      }
    >
      {content && <div className="confirmation-modal__content">{content}</div>}
    </Modal>
  );
};
